import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";

export const FormToggleButton = styled(MuiToggleButton)(({selectedcolor}) => ({
  "&.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: selectedcolor
  }
}));